import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

function AlertTimeout(props) {
  return (
    <SweetAlert
      warning
      showCancel
      cancelBtnText='Stay Connected'
      cancelBtnBsStyle='light'
      confirmBtnText='Yes, Logout!'
      confirmBtnBsStyle='warning'
      title='Oops!'
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      focusCancelBtn
    >
      Your Session is About to Expire!
    </SweetAlert>
  );
}
export default AlertTimeout;
